import { call } from 'redux-saga/effects';
import { AuthResource } from '../../core/resources/auth.resource';
import { IApiLogin } from '../../models/auth/auth.types';

export function* login(
  username: string,
  password: string,
  captcha?: string,
  blackbox?: string
) {
  const apiLogin: IApiLogin = yield call(
    AuthResource.login,
    username,
    password,
    captcha,
    blackbox
  );

  return apiLogin;
}
